function toggleWishlist(handle, button) {
  let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

  if (wishlist.includes(handle)) {
    wishlist = wishlist.filter(item => item !== handle);
    if (button) button.classList.remove('active');
  } else {
    wishlist.push(handle);
    if (button) button.classList.add('active');
  }

  localStorage.setItem('wishlist', JSON.stringify(wishlist));
}
